// @ts-nocheck

"use client"

import React, { useState } from "react"
import {
    Tabs,
    TabsHeader,
    TabsBody,
    Tab,
    TabPanel,
  } from "@material-tailwind/react"
import ReactPlayer from 'react-player/lazy'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode, Navigation, Thumbs } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/navigation'
import 'swiper/css/thumbs'
import "./styles.scss"
import useMedia from "use-media"
import { API_URI } from "@/config/API_URI"

const GalleryTabs = ({ images, title }) => {
    const isWide = useMedia({ minWidth: 768 })
    const [activeTab, setActiveTab] = React.useState("html")
    const [thumbsSwiper, setThumbsSwiper] = useState(null)
    const data = [
        {
            label: "Photos",
            value: "html",
            desc: <div className="flex flex-col gap-5 justify-center items-center w-full">
                <Swiper
                    style={{
                        '--swiper-navigation-color': '#EBD29F',
                        '--swiper-pagination-color': '#EBD29F',
                    }}
                    loop={true}
                    spaceBetween={10}
                    navigation={true}
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="galleryTabs2"
                >
                    {(images && images.length > 0) && images.map((image, index) =>
                        <SwiperSlide key={index}>
                            <img
                                src={`${image || ""}`}
                                alt={title || ""}
                            />
                        </SwiperSlide>
                    )}
                </Swiper>
                <Swiper
                    onSwiper={setThumbsSwiper}
                    loop={true}
                    spaceBetween={10}
                    slidesPerView={4}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="galleryTabs"
                >
                    {(images && images.length > 0) && images.map((image, index) =>
                        <SwiperSlide key={index}>
                            <img
                                src={`${image || ""}`}
                                alt={title || ""}
                            />
                        </SwiperSlide>
                    )}
                </Swiper>
            </div>,
        },
        // {
        //     label: "Movie",
        //     value: "react",
        //     desc: <ReactPlayer url="https://www.youtube.com/watch?v=rn8DH24U_7Q" controls muted width="100%" height={isWide ? 750 : 300} />,
        // },
        // {
        //     label: "Explore the area",
        //     value: "vue",
        //     desc: <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d387191.036018456!2d-74.30932263448818!3d40.697539972124765!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c24fa5d33f083b%3A0xc80b8f06e177fe62!2sNowy%20Jork%2C%20Stany%20Zjednoczone!5e0!3m2!1spl!2spl!4v1697414401556!5m2!1spl!2spl" width="1380" height="700" style={{ border: 0 }} allowfullscreen={false} loading="lazy" referrerpolicy="no-referrer-when-downgrade" />,
        // },
    ]
    return (
        <section className="destinations-map__wrapper">
            <div className="destinations-map__container">
                <Tabs value={activeTab} className="w-full">
                    <TabsHeader
                        className="rounded-none border-b border-blue-gray-50 bg-transparent p-0"
                        indicatorProps={{
                        className:
                            "bg-transparent border-b-2 border-gray-900 shadow-none rounded-none !font-['Comfortaa']",
                        }}
                    >
                        {data.map(({ label, value }) => (
                        <Tab
                            key={value}
                            value={value}
                            onClick={() => setActiveTab(value)}
                            className={activeTab === value ? "text-white border-b-[#EBD29F] border-b-[4px] text-left justify-start items-start" : "text-white border-b-[4px] text-left justify-start items-start"}
                        >
                            <span className="font-['Comfortaa'] font-semibold uppercase">{label}</span>
                        </Tab>
                        ))}
                    </TabsHeader>
                    <TabsBody className="w-full py-2">
                        {data.map(({ value, desc }) => (
                            <TabPanel key={value} value={value} className="w-full font-['Comfortaa'] flex flex-col gap-1 justify-center items-center">
                                <div className="tabs-body__wrapper w-full h-fit text-white font-['Comfortaa']">
                                    {desc}
                                </div>
                            </TabPanel>
                        ))}
                    </TabsBody>
                </Tabs>
            </div>
        </section>
    )
}

export default GalleryTabs